/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ContentMasterOtherSourceStatusView = {
    /**
     * Other channel identifier where the product is already tracked — `plattform:N` or `shop:N`.
     */
    source?: string;
    /**
     * Local Content Master status of the product on that other source.
     */
    processingStatus?: ContentMasterOtherSourceStatusView.processingStatus;
};
export namespace ContentMasterOtherSourceStatusView {
    /**
     * Local Content Master status of the product on that other source.
     */
    export enum processingStatus {
        NEW = 'new',
        IN_PROGRESS = 'in_progress',
        DONE = 'done',
        BULK_GENERATE_QUEUED = 'bulk_generate_queued',
        BULK_GENERATE_IN_PROGRESS = 'bulk_generate_in_progress',
        BULK_GENERATE_DONE = 'bulk_generate_done',
        BULK_GENERATE_FAILED = 'bulk_generate_failed',
        BULK_APPLY_QUEUED = 'bulk_apply_queued',
        BULK_APPLY_IN_PROGRESS = 'bulk_apply_in_progress',
        BULK_APPLY_FAILED = 'bulk_apply_failed',
    }
}

